import * as Sentry from '@sentry/react';

const DSN = import.meta.env.VITE_SENTRY_DSN;
const IS_PROD = import.meta.env.PROD;

/**
 * Initialize Sentry for error tracking.
 * Disabled in development, enabled in staging/production via DSN presence.
 */
export function initSentry() {
  if (!DSN) {
    if (IS_PROD) {
      console.warn('Sentry DSN is missing in production environment.');
    }
    return;
  }

  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE,
    enabled: IS_PROD
  });
}
